import { API_URL } from "../../constans/roles";
import { fetchJson } from "../fetch";

const tableUrl = (tableName, suffix = "") => `${API_URL}/${tableName}${suffix}`;

export const getTableOptions = async (tableName) =>
  fetchJson(tableUrl(tableName, "/options"), { method: "GET" });

export const getTableRecords = async (tableName) =>
  fetchJson(tableUrl(tableName, "/"), { method: "GET" });

export const getTableRecordsByFilter = async (tableName, queryString) =>
  fetchJson(tableUrl(tableName, `/get?${queryString}`), { method: "GET" });

export const getTableRecordsPage = async (tableName, pageNumber, queryString) =>
  fetchJson(tableUrl(tableName, `/get/${pageNumber}?${queryString}`), {
    method: "GET",
  });

export const getTableRecordById = async (tableName, id) =>
  fetchJson(tableUrl(tableName, `/getOne/${id}`), { method: "GET" });

export const getTableCount = async (tableName) =>
  fetchJson(tableUrl(tableName, "/getCount"), { method: "GET" });

export const getTableCountPerFormat = async (tableName) =>
  fetchJson(tableUrl(tableName, "/getCountPerFormat"), { method: "GET" });

export const getRandomTableByFormat = async (tableName, format) =>
  fetchJson(tableUrl(tableName, `/getRandomByFormat?format=${encodeURIComponent(format)}`), {
    method: "GET",
  });

export const addTableRecord = async (tableName, payload) =>
  fetchJson(tableUrl(tableName, "/add"), {
    method: "POST",
    body: payload,
  });

export const updateTableRecord = async (tableName, id, payload) =>
  fetchJson(tableUrl(tableName, `/edit/${id}`), {
    method: "PUT",
    body: payload,
  });

export const removeTableRecord = async (tableName, id) =>
  fetchJson(tableUrl(tableName, "/remove"), {
    method: "DELETE",
    body: { _id: id },
  });
